import React, { useEffect, useState } from 'react';

const App = () => {
  const [ports, setPorts] = useState([]);

  useEffect(() => {
    fetchPorts();
  }, []);

  const fetchPorts = async () => {
    try {
      const response = await fetch('http://localhost:5000/check-ports');
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      setPorts(data);
    } catch (error) {
      console.error('Error fetching ports:', error);
    }
  };

  return (
    <div>
      <h1>Port Scanner</h1>
      <table>
        <thead>
          <tr>
            <th>Host</th>
            <th>Port 80</th>
            <th>Port 443</th>
            <th>Port 22</th>
            <th>Port 8080</th>
          </tr>
        </thead>
        <tbody>
          {ports.map((portData) => (
            <tr key={portData.target}>
              <td>{portData.target}</td>
              {portData.openPorts.map((portStatus, index) => (
                <td key={index}>{portStatus ? 'Open' : 'Closed'}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default App;
